import * as Blockly from "blockly";

/**
 * Arduino code generator.
 */
const ArduinoBlockly: any = new Blockly.Generator("Arduino");

// Rezerve kelimeler (Arduino'ya özel)
ArduinoBlockly.addReservedWords(`
  setup,loop,if,else,for,switch,case,while,do,break,continue,return,goto,define,include,
  HIGH,LOW,INPUT,OUTPUT,INPUT_PULLUP,true,false,interger,floating,point,void,boolean,
  char,unsigned,byte,int,word,long,float,double,string,String,array,static,volatile,
  const,sizeof,pinMode,digitalWrite,digitalRead,analogReference,analogRead,analogWrite,
  tone,noTone,shiftOut,shiftIn,pulseIn,millis,micros,delay,delayMicroseconds,min,max,
  abs,constrain,map,pow,sqrt,sin,cos,tan,randomSeed,random,lowByte,highByte,bitRead,
  bitWrite,bitSet,bitClear,bit,attachInterrupt,detachInterrupt,interrupts,noInterrupts
`);

/**
 * Order of operation ENUMs.
 *
 */
ArduinoBlockly.ORDER_ATOMIC = 0; // 0 "" ...
ArduinoBlockly.ORDER_UNARY_POSTFIX = 1; // expr++ expr-- () [] .
ArduinoBlockly.ORDER_UNARY_PREFIX = 2; // -expr !expr ~expr ++expr --expr
ArduinoBlockly.ORDER_FUNCTION_CALL = 2; // () [];
ArduinoBlockly.ORDER_MODULUS = 3; // %;
ArduinoBlockly.ORDER_MULTIPLICATIVE = 3; // * / % ~/
ArduinoBlockly.ORDER_DIVISION = 3; // /
ArduinoBlockly.ORDER_MULTIPLICATION = 3; // *
ArduinoBlockly.ORDER_ADDITIVE = 4; // + -
ArduinoBlockly.ORDER_SUBTRACTION = 4; // -
ArduinoBlockly.ORDER_ADDITION = 4; // +
ArduinoBlockly.ORDER_SHIFT = 5; // << >>
ArduinoBlockly.ORDER_RELATIONAL = 6; // is is! >= > <= <
ArduinoBlockly.ORDER_EQUALITY = 7; // == != === !==
ArduinoBlockly.ORDER_BITWISE_AND = 8; // &
ArduinoBlockly.ORDER_BITWISE_XOR = 9; // ^
ArduinoBlockly.ORDER_BITWISE_OR = 10; // |
ArduinoBlockly.ORDER_LOGICAL_AND = 11; // &&
ArduinoBlockly.ORDER_LOGICAL_OR = 12; // ||
ArduinoBlockly.ORDER_CONDITIONAL = 13; // expr ? expr : expr
ArduinoBlockly.ORDER_ASSIGNMENT = 14; // = *= /= ~/= %= += -= <<= >>= &= ^= |=
ArduinoBlockly.ORDER_COMMA = 15; // ,
ArduinoBlockly.ORDER_UNARY_NEGATION = 16;
ArduinoBlockly.ORDER_MEMBER = 17;
ArduinoBlockly.ORDER_NONE = 99; // (...)

/**
 * List of outer-inner pairings that do NOT require parentheses.
 * @type {!Array.<!Array.<number>>}
 */
ArduinoBlockly.ORDER_OVERRIDES = [
  // (foo()).bar -> foo().bar
  // (foo())[0] -> foo()[0]
  [ArduinoBlockly.ORDER_FUNCTION_CALL, ArduinoBlockly.ORDER_MEMBER],
  // (foo())() -> foo()()
  [ArduinoBlockly.ORDER_FUNCTION_CALL, ArduinoBlockly.ORDER_FUNCTION_CALL],
  // (foo.bar).baz -> foo.bar.baz
  // (foo.bar)[0] -> foo.bar[0]
  // (foo[0]).bar -> foo[0].bar
  // (foo[0])[1] -> foo[0][1]
  [ArduinoBlockly.ORDER_MEMBER, ArduinoBlockly.ORDER_MEMBER],
  // (foo.bar)() -> foo.bar()
  // (foo[0])() -> foo[0]()
  [ArduinoBlockly.ORDER_MEMBER, ArduinoBlockly.ORDER_FUNCTION_CALL],
  // !(!foo) -> !!foo
  [ArduinoBlockly.ORDER_LOGICAL_NOT, ArduinoBlockly.ORDER_LOGICAL_NOT],
  // a * (b * c) -> a * b * c
  [ArduinoBlockly.ORDER_MULTIPLICATION, ArduinoBlockly.ORDER_MULTIPLICATION],
  // a + (b + c) -> a + b + c
  [ArduinoBlockly.ORDER_ADDITION, ArduinoBlockly.ORDER_ADDITION],
  // a && (b && c) -> a && b && c
  [ArduinoBlockly.ORDER_LOGICAL_AND, ArduinoBlockly.ORDER_LOGICAL_AND],
  // a || (b || c) -> a || b || c
  [ArduinoBlockly.ORDER_LOGICAL_OR, ArduinoBlockly.ORDER_LOGICAL_OR],
];

// Kod üretimi başlatıldığında çağrılır
ArduinoBlockly.init = function (workspace: Blockly.Workspace) {
  ArduinoBlockly.includes_ = Object.create(null);
  ArduinoBlockly.definitions_ = Object.create(null);
  ArduinoBlockly.variables_ = Object.create(null);
  ArduinoBlockly.setups_ = Object.create(null);

  if (!ArduinoBlockly.variableDB_) {
    ArduinoBlockly.variableDB_ = new Blockly.Names(
      ArduinoBlockly.RESERVED_WORDS_
    );
  } else {
    ArduinoBlockly.variableDB_.reset();
  }

  ArduinoBlockly.variableDB_.setVariableMap(workspace.getVariableMap());

  /*const variableMap = workspace.getVariableMap();
  const allVariables = variableMap.getAllVariables();

  const variablesByType: Record<string, string[]> = {};
  for (const variable of allVariables) {
    const type = variable.getType() || "float";
    if (!variablesByType[type]) {
      variablesByType[type] = [];
    }
    variablesByType[type].push(variable.getName());
  }

  ArduinoBlockly.definitions_["variables"] = "";
  for (const [type, names] of Object.entries(variablesByType)) {
    ArduinoBlockly.definitions_["variables"] += `${type} ${names.join(
      ", "
    )};\n`;
  }*/
};

// Kod üretimi bittiğinde çağrılır, tüm parçaları birleştirir
ArduinoBlockly.finish = function (code: string) {
  const includes = Object.values(ArduinoBlockly.includes_).join("\n");
  const definitions = Object.values(ArduinoBlockly.definitions_).join("\n");
  const setups = Object.values(ArduinoBlockly.setups_).join("\n");

  const setupCode = `void setup() {\n  ${setups}\n}`;
  const loopCode = `void loop() {\n  ${code.replace(/\n/g, "\n  ")}\n}`;

  ArduinoBlockly.variableDB_.reset();
  return [includes, definitions, setupCode, loopCode]
    .filter(Boolean)
    .join("\n\n");
};

// Bağımsız ifade satırını noktalı virgülle tamamlar
ArduinoBlockly.scrubNakedValue = function (line: string) {
  return `${line};\n`;
};

// Satır içi yorumları ve takip eden blokları işler
ArduinoBlockly.scrub_ = function (
  block: Blockly.Block,
  code: string,
  opt_thisOnly?: boolean
) {
  let commentCode = "";
  if (!block.outputConnection || !block.outputConnection.targetConnection) {
    const comment = block.getCommentText();
    if (comment) {
      commentCode += ArduinoBlockly.prefixLines(comment, "// ") + "\n";
    }
    for (const input of block.inputList) {
      if (input.type === ("input_value" as any) && input.connection) {
        const child = input.connection.targetBlock();
        if (child) {
          const nestedComment =
            Blockly.Generator.prototype.allNestedComments(child);
          if (nestedComment) {
            commentCode +=
              ArduinoBlockly.prefixLines(nestedComment, "// ") + "\n";
          }
        }
      }
    }
  }

  const nextBlock = block.nextConnection && block.nextConnection.targetBlock();
  const nextCode = ArduinoBlockly.blockToCode(nextBlock) || "";
  return commentCode + code + nextCode;
};

// Yardımcı fonksiyon: Satır başına önek ekler
ArduinoBlockly.prefixLines = function (text: string, prefix: string) {
  return text
    .split("\n")
    .map((line) => prefix + line)
    .join("\n");
};

export default ArduinoBlockly;
